<div class="hflex-075 flex-align-items-center sort-wrapper" [class.is-active]="isActive()">
  <span><ng-content></ng-content></span>
  @if (isActive()) {
    <mdw-icon
      class="x-small-icon"
      [icon]="icons.Chevron_Down"
      [style.transform]="'rotate(' + sortIconRotation() + 'deg)'"
    ></mdw-icon>
  } @else {
    <mdw-icon class="hover-icon x-small-icon" [icon]="icons.Chevron_Down"></mdw-icon>
  }
</div>
